const STORAGE_KEY = 'certificatesAnnouncementSessionDismissedUserId';

export const markCertificatesAnnouncementDismissedForSession = (
  userId: number | undefined,
): void => {
  if (userId == null) {
    return;
  }

  try {
    localStorage.setItem(STORAGE_KEY, String(userId));
  } catch {
    // localStorage may be unavailable (private mode, disabled storage) — fail open and just re-show next page load.
  }
};

export const isCertificatesAnnouncementDismissedForSession = (userId: number): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEY) === String(userId);
  } catch {
    return false;
  }
};

export const clearCertificatesAnnouncementSessionDismissal = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
};
